import {
  UnifiedViewer,
  UnifiedViewerEventType,
} from '@cognite/unified-file-viewer';

type Ref<T> = {
  current: T;
};

export type ViewerState = {
  viewer: UnifiedViewer | null;
  cleanup: (() => void) | null;
};

export const attachZoomEndViewportRefresh = (
  viewer: UnifiedViewer
): (() => void) => {
  let rafId: number | null = null;

  const refreshDocumentRender = () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    rafId = requestAnimationFrame(() => {
      rafId = null;
      viewer.onViewportChange();
    });
  };

  viewer.addEventListener(
    UnifiedViewerEventType.ON_ZOOM_END,
    refreshDocumentRender
  );

  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    viewer.removeEventListener(
      UnifiedViewerEventType.ON_ZOOM_END,
      refreshDocumentRender
    );
  };
};

export const createViewerRefHandler = (viewerStateRef: Ref<ViewerState>) => {
  return (ref: UnifiedViewer | null) => {
    viewerStateRef.current.cleanup?.();
    viewerStateRef.current = {
      viewer: ref,
      cleanup: ref ? attachZoomEndViewportRefresh(ref) : null,
    };
  };
};
